<template>
  <div class="declaracao">
    <table style="width: 100%; margin-top: 10px;">
      <tr>
        <td colspan="3">
          <table style="width: 100%;">
            <tr>
              <td colspan="3" style="width: 30em;" class="noPad">
                <table style="width: 100%;">
                  <tr>
                    <td class="border headerText" height="40">
                      <strong>DECLARAÇÃO DE CONTEÚDO</strong>
                      <strong class="tracking">{{ order.tracking }}</strong>
                    </td>
                  </tr>
                </table>
              </td>
              <td rowspan="4"><!-- --></td>
              <td rowspan="4" class="border bottomText">
                <p>CARIMBO DA UNIDADE</p>
              </td>
            </tr>
            <tr>
              <td colspan="3"><!-- --></td>
            </tr>
            <tr>
              <td colspan="3" class="border exclusivos">CAMPOS EXCLUSIVOS DOS CORREIOS</td>
            </tr>
            <tr>
              <td height="20" class="border topText">
                <p>UNIDADE DE POSTAGEM</p>
              </td>
              <td width="3"><!-- --></td>
              <td height="20" class="border topText">
                <p>NÚMERO DO REGISTRO</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding-top: .5em">
          <table style="width: 100%; border: 1px solid #000">
            <tr class="border">
              <td colspan="2">
                <strong>REMETENTE:</strong>
                <span>{{ order.from.name }}</span>
              </td>
            </tr>
            <tr class="border">
              <td colspan="2">
                <strong>CPF/CNPJ:</strong>
                <span>{{ order.from.company_document || order.from.document || '' }}</span>
              </td>
            </tr>
            <tr class="border">
              <td colspan="2">
                <strong>ENDEREÇO:</strong>
                <span>{{ order.from.address }}, {{ order.from.location_number }}. <template v-if="order.from.complement">{{ order.from.complement }}.</template> <template v-if="order.from.district">Bairro {{ order.from.district }}</template></span>
              </td>
            </tr>
            <tr class="border">
              <td style="width: 40em">
                <strong>CIDADE/UF:</strong>
                <span>{{ order.from.city }} / {{ order.from.state_abbr }}</span>
              </td>
              <td style="border-left: 1px solid #000">
                <strong>CEP:</strong>
                <span>{{ order.from.postal_code | postal_code }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding-top: .5em">
          <table style="width: 100%; border: 1px solid #000">
            <tr class="border">
              <td colspan="2">
                <strong>DESTINATÁRIO:</strong>
                <span>{{ order.to.name }}</span>
              </td>
            </tr>
            <tr class="border">
              <td colspan="2">
                <strong>CPF/CNPJ:</strong>
                <span>{{ order.to.company_document || order.to.document || '' }}</span>
              </td>
            </tr>
            <tr class="border">
              <td colspan="2">
                <strong>ENDEREÇO:</strong>
                <span>{{ order.to.address }}, {{ order.to.location_number }}. <template v-if="order.to.complement">{{ order.to.complement }}.</template> <template v-if="order.to.district">Bairro {{ order.to.district }}</template></span>
              </td>
            </tr>
            <tr class="border">
              <td style="width: 40em">
                <strong>CIDADE/UF:</strong>
                <span>{{ order.to.city }} / {{ order.to.state_abbr }}</span>
              </td>
              <td style="border-left: 1px solid #000">
                <strong>CEP:</strong>
                <span>{{ order.to.postal_code | postal_code }}</span>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding-top: .5em">
          <table style="width: 100%; border: 1px solid #000">
            <tr class="border declaracao-data-header">
              <td colspan="3">
                <strong>IDENTIFICAÇÃO DOS BENS</strong>
              </td>
            </tr>

            <tr class="border declaracao-center">
              <td><strong>DISCRIMINAÇÃO DO CONTEÚDO</strong></td>
              <td style="width: 10em; border-left: 1px solid #000;"><strong>QUANTIDADE</strong></td>
              <td style="width: 10em; border-left: 1px solid #000;"><strong>VALOR</strong></td>
            </tr>

            <tr class="border declaration-items" v-for="product in order.products">
              <td>{{ product.name | upper }}</td>
              <td style="width: 10em; text-align: center; border-left: 1px solid #000;">{{ product.quantity }}</td>
              <td style="width: 10em; text-align: center; border-left: 1px solid #000;">{{ (product.unitary_value * product.quantity) | currency }}</td>
            </tr>

            <template v-if="order.products.length < 10">
              <tr class="border" v-for="n in (10 - order.products.length)">
                <td>&nbsp;</td>
                <td style="width: 10em; text-align: center; border-left: 1px solid #000;">&nbsp;</td>
                <td style="width: 10em; text-align: center; border-left: 1px solid #000;">&nbsp;</td>
              </tr>
            </template>

            <tr class="border declaracao-center">
              <td style="background: #c7c7c7;"><strong style="text-align: right;font-size: 8pt;">TOTAIS</strong></td>
              <td style="width: 10em; text-align: center; border-left: 1px solid #000;"><strong v-if="order.products.length">{{ totals.quantity }}</strong></td>
              <td style="width: 10em; text-align: center; border-left: 1px solid #000;"><strong v-if="order.products.length">{{ totals.price | currency }}</strong></td>
            </tr>
            <tr class="border declaracao-center">
              <td style="background: #c7c7c7;"><strong style="text-align: right;font-size: 8pt;">PESO TOTAL (kg)</strong></td>
              <td colspan="2" style="width: 10em; text-align: center; border-left: 1px solid #000;"><strong v-if="order.weight > 0">{{ order.weight }} kg</strong></td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding-top: .5em">
          <table style="width: 100%; border: 1px solid #000">
            <tr class="border declaracao-data-header">
              <td colspan="2">
                <strong>DECLARAÇÃO</strong>
              </td>
            </tr>
            <tr style="font-size: 9pt;">
              <td colspan="2" class="dec-responsabilities">
                <p>Declaro que não me enquadro no conceito de contribuinte previsto no art. 4º da Lei Complementar nº 87/1996, uma vez que não realizo, com habitualidade ou em volume que caracterize intuito comercial, operações de circulação de mercadoria, ainda que se iniciem no exterior, ou estou dispensado da emissão da nota fiscal por força da legislação tributária vigente, responsabilizando-me, nos termos da lei e a quem de direito, por informações inverídicas.</p>
                <p>Declaro que estou dispensado da emissão de nota fiscal por força da legislação tributária vigente, responsabilizando-me, em todas as circunstâncias legais, sobre qualquer informação inverídica declarada. Ainda, declaro que nesta embalagem não há qualquer conteúdo ilícito, nocivo, tóxico, perigoso, nem a presença de animais vivos ou mortos, objetos com regulamentação específica de posse ou porte ou com comercialização ou uso proibido no Brasil.</p>
                <p><strong>Declaro estar plenamente ciente de que estou sujeito às penalidades legais civis e criminais em caso de declaração inverídica, incompleta e/ou incorreta relacionada ao conteúdo por mim informado neste documento.</strong></p>
                <p>Declaro ainda que não estou postando conteúdo inflamável, explosivo, causador de combustão espontânea, tóxico, corrosivo, gás ou qualquer outro conteúdo que conste na lista de proibições e restrições disponível no site dos Correios: <a href="http://www.correios.com.br/precisa-de-ajuda/proibicoes-e-restricoes/proibicoes-e-restricoes" rel="noreferrer noopener" target="_blank">http://www.correios.com.br/precisa-de-ajuda/proibicoes-e-restricoes/proibicoes-e-restricoes</a>.</p>
              </td>
            </tr>
            <tr style="font-size: 9pt;">
              <td style="padding-top: 15px; width: 35em;">
                <p class="txtData"><span>{{ moment(order.generated_at).format('dddd') }}</span>, <span>{{ moment(order.generated_at).format('DD') }}</span> de <span>{{ moment(order.generated_at).format('MMMM') }}</span> de <span>{{ moment(order.generated_at).format('YYYY') }}</span></p>
              </td>
              <td style="text-align: center; padding-top: 15px;">
                <p>________________________________________________</p>
              </td>
            </tr>
            <tr style="font-size: 8pt;">
              <td style="padding: 0 5px 5px 5px;"><!-- --></td>
              <td style="text-align: center; padding: 0 5px 5px 5px;">
                <p>Assinatura do<br>Declarante/Remetente</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr class="declaracao-data">
        <td colspan="3" style="padding-top: .5em">
          <table style="width: 100%; border: 1px solid #000">
            <tr>
              <td colspan="2" style="padding-bottom: 0;">
                <p style="font-size: 7pt;"><strong>OBSERVAÇÃO:</strong></p>
              </td>
            </tr>
            <tr style="font-size: 8pt;">
              <td colspan="2">
                <p style="text-align: justify;">Constitui crime contra a ordem tributária suprimir ou reduzir tributo, ou contribuição social e qualquer acessório (Lei 8.137/90 Art. 1º, V).</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    props: {
      order: {
        type: Object,
        required: true
      }
    },

    methods: {
      moment
    },

    computed: {
      totals: function () {
        let price = 0;
        let quantity = 0;
        this.order.products.forEach((e) => {
          price += e.quantity * e.unitary_value;
          quantity += e.quantity;
        });

        return {
          'price': price,
          'quantity': quantity
        };
      }
    },

    filters: {
      postal_code(value) {
        return String(value).padStart(8, '0').replace(/(\d{5})(\d{3})$/, '$1-$2');
      },
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
      upper(text) {
        return String(text || '').toUpperCase();
      }
    },

    created() {
      moment.locale('pt_br');
    },
  }
</script>

<style lang="stylus" scoped>
td
  padding 4px
  &.noPad
    padding 0
.dec-responsabilities
  text-align justify
  text-indent 20px
  p
    &:not(:last-of-type)
      margin-bottom 10px
  .declaracao-data
  .dec-responsabilities
    strong
      &:is(strong)
        font-size inherit
.border
  border 1px solid #000
  &.declaration-items
    word-break break-word
.headerText
  vertical-align middle
  font-size 15pt
  strong
    display block
    text-align center
  .tracking
    font-size 14pt
    padding-top 5px
.topText
  vertical-align top
  font-size 6pt
.bottomText
  vertical-align bottom
  font-size 6pt
  text-align center
.exclusivos
  background #c7c7c7
  text-align center
  font-size 8pt
.declaracao
  color #000
  font-size 12pt
  font-family Arial
  .declaracao-header
    font-size 15pt
    text-align center
    vertical-align middle
  .txtData
    span
      display inline-block
      border-bottom 1px solid #000
      padding 0 20px
  .declaracao-data
    font-size 10pt
    strong
    span
      font-size 10pt
    tr
      td
        padding 4px
  .declaracao-data-header
    background #c7c7c7
    strong
      display block
      text-align center
      letter-spacing 1px
  .declaracao-center
    strong
      display block
      text-align center
  strong
    font-weight bold


@media print
  .declaracao
    padding 5mm !important
    .declaracao-header
      font-size 11pt
      text-align center
      vertical-align middle
</style>
